export default __webpack_public_path__ + "static/dressing.cover-0c1c124556a5b39d59874952a8303acd.jpg";